import { LogInForm } from "@/components/auth/log-in.form";
import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import type { LogInFormValues } from "@/services/auth/auth.schema";
import { authApi } from "@/services/auth/auth.api";
import { createFetch } from "@better-fetch/fetch";
import SuperJSON from "superjson";
import { useNavigate } from "react-router";

const $fetch = createFetch({
  baseURL: process.env.BUN_PUBLIC_API_URL,
  jsonParser: (text): unknown => {
    if (!text) return;
    if (text.startsWith('{"json"')) {
      return SuperJSON.parse(text);
    }

    return JSON.parse(text);
  },
  throw: true,
});

export default function LogInPage() {
  const navigate = useNavigate();
  const { mutate } = useMutation<{ token: string }, Error, LogInFormValues>({
    mutationFn: async (form: LogInFormValues) =>
      await $fetch(authApi.logIn.route(), {
        method: "POST",
        body: form,
      }),
    onSuccess: ({ token }) => {
      toast.success("Witamy ponownie !");
      localStorage.setItem("auth-token", token);
      navigate("/");
    },
    onError: (e) => {
      if (e instanceof Error) {
        toast.error(`Wystąpil błąd: ${e.message}`);
      }
      console.error(e);
    },
  });
  return (
    <div className="bg-muted flex min-h-svh flex-col items-center justify-center p-6 md:p-10">
      <div className="w-full max-w-sm md:max-w-md">
        <LogInForm onSubmit={mutate} />
      </div>
    </div>
  );
}
